<template>
  <div class="rc-hyperlink-design">
   <a><span>{{initComponent.name}}</span> 链接文本</a>
  </div>
</template>

<script>
import {componentMixin} from '../mixins'

export default {
  name: 'rc-hyperlink',
  props: ['initComponent'],
  mixins: [componentMixin],
  data () {
    return {
      component: this.initComponent
    }
  }
}
</script>
<style lang="scss">
  .rc-hyperlink-design {
    > a {
      color: var(--primary, #5DB0F2);
      overflow: hidden;
      white-space: nowrap;
      cursor: pointer;
      span {
        margin-right: 34px;
        color: #2A2929;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/hyperlink/rc-hyperlink.vue